import React, { FC } from "react";
import { SingleFilter } from "./singleFilter";
import { demoFilters, getFilterProps } from "./helper";
import { IconCheck } from "../../../../utils/icons";

// Filters the library down to proposal example videos (s3_files.demo=true,
// toggled per video in the settings panel).
interface Props {
  onFilterSelect: (key: string, id?: string) => void;
  queryFilters?: any;
}

export const DemoFilter: FC<Props> = ({ onFilterSelect, ...rest }) => (
  <SingleFilter
    {...rest}
    {...getFilterProps(demoFilters, "demo", "Demo Videos")}
    updateSearch={onFilterSelect}
    icon={IconCheck}
  />
);
